module.exports = __webpack_public_path__ + "img/gutsugutsu.fb0c7989.jpg";